import FeatureInfo from './FeatureInfo'
import Coordinates from './Coordinates'
import GeoLocation from './GeoLocation'
import Attribution from './Attribution'


export default {
  FeatureInfo,
  Coordinates,
  GeoLocation,
  Attribution
}